import { useEffect, useState } from "react";
import { CheckCircle2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { JobForm } from "@/components/jobs/JobForm";
import { Eyebrow } from "@/components/public/Motion";

export default function RequestJob() {
  const [hospitals, setHospitals] = useState([]);
  const [busy, setBusy] = useState(false);
  const [ref, setRef] = useState("");
  const [err, setErr] = useState("");
  useEffect(() => { api.get("/public/hospitals").then((r) => setHospitals(r.data)); }, []);
  const submit = async (body) => {
    setBusy(true); setErr("");
    try { const { data } = await api.post("/public/job-requests", body); setRef(data.ref); window.scrollTo({ top: 0, behavior: "smooth" }); } catch (e) { setErr(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="mx-auto max-w-4xl px-5 pb-24 pt-32" data-testid="request-job-page">
      <Eyebrow>For NHS staff</Eyebrow>
      <h1 className="mt-3 text-4xl font-black tracking-tight sm:text-5xl">Request a blood bike</h1>
      <p className="mt-4 max-w-2xl text-white/75">Send a transport request for blood, samples, breast milk, FMT and other urgent items. The duty controller checks every web request before a rider is sent. Regular users can ask us for a hospital portal login. For urgent, out-of-hours requests please phone the duty controller as usual.</p>
      {ref ? (
        <div className="mt-10 rounded-3xl bg-white p-8 text-black" data-testid="request-job-success"><CheckCircle2 className="h-12 w-12 text-emerald-600" /><h2 className="mt-4 text-2xl font-black">Request received</h2><p className="mt-2">Your reference is <b data-testid="request-job-ref">{ref}</b>. The duty controller will be in touch on the number you gave.</p>
          <button onClick={() => setRef("")} data-testid="request-send-another" className="mt-6 rounded-full bg-black px-6 py-3 font-bold text-white">Send another</button></div>
      ) : (
        <div className="mt-10 rounded-3xl bg-white p-6 text-black sm:p-8">{err && <p className="mb-4 rounded-xl bg-red-100 p-3 text-sm text-red-700" data-testid="request-job-error">{err}</p>}{hospitals.length > 0 && <JobForm hospitals={hospitals} onSubmit={submit} publicMode busy={busy} />}</div>
      )}
    </div>
  );
}
